import React from "react"

const Email = () => {
  return (
    <svg
      width="22"
      height="17"
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.50924 0.106842H19.015C19.7026 0.0993347 20.3643 0.369202 20.8506 0.855469C21.3369 1.34177 21.6068 2.00345 21.5992 2.69113V14.3204C21.6068 15.0081 21.3369 15.6698 20.8506 16.1561C20.3643 16.6424 19.7026 16.9122 19.015 16.9047H3.50924C2.82157 16.9122 2.15987 16.6424 1.67359 16.1561C1.1873 15.6698 0.917443 15.0081 0.924958 14.3204V2.69113C0.917443 2.00345 1.1873 1.34177 1.67359 0.855469C2.15987 0.369202 2.82157 0.0993347 3.50924 0.106842ZM11.6498 10.3148L19.4026 4.50012C19.5873 4.36163 19.684 4.13516 19.6564 3.90598C19.6288 3.67682 19.481 3.4798 19.2688 3.38913C19.0565 3.29846 18.812 3.32791 18.6273 3.4664L11.2621 8.99033L3.89691 3.4664C3.61146 3.25232 3.2065 3.31018 2.99241 3.59561C2.77832 3.88107 2.83617 4.28604 3.12163 4.50012L10.8745 10.3148C11.1042 10.4871 11.4201 10.4871 11.6498 10.3148Z"
        fill="#34A0B6"
      />
    </svg>
  )
}

export default Email
